import { render, staticRenderFns } from "./Keywordwizzard.vue?vue&type=template&id=2310ca1d"
import script from "./Keywordwizzard.vue?vue&type=script&lang=js"
export * from "./Keywordwizzard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports